const ENV = import.meta.env;

export const API_URL = ENV.VITE_API_URL;
export const CLASSIFICATION_URL = ENV.VITE_CLASSIFICATION_URL;
export const EXTRACTION_URL = ENV.VITE_EXTRACTION_URL;
export const PUBLISHER_URL = ENV.VITE_PUBLISHER_URL;
export const CONSUMER_URL = ENV.VITE_CONSUMER_URL;